import PropTypes from "prop-types";
import CircleIIcon from "../../../../assets/circle_i.svg";
import { Select } from "antd";
import { Input } from "@vds/inputs";
import { IsRequiredValidation } from "../formValidation";
import { SearchBox } from "@mapbox/search-js-react";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../../store/actions/deviceProfile";
import ATSToolTip from "../../../../global/components/ATSToolTip";

function NewLocationFormGroup(props) {
  const { stateSelectorIndex } = props;
  const dispatch = useDispatch();
  const { formFields, alertGroupOptions } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
    alertGroupOptions: state.deviceProfile.ui.form.alertGroups,
  }));

  const handleFormField = (field, value) => {
    if (field !== "radius") {
      const validator = IsRequiredValidation(field, value);
      let mapBoxTheme = {
        cssText: `
                .Input {
                    height: 43px;
                    font-size: 1rem;
                    font-weight: 400;
                    color: #212529;
                    font-family: system-ui;
                    pointer-events: none;
                }
                .ClearBtn {
                    display: none !important;
                }
            `,
        variables: {
          unit: "14px",
          padding: "0.5em",
          border: "1px solid rgba(111, 113, 113, 1)",
          borderRadius: "4px",
          boxShadow: "none",
        },
      };
      if (field === "address") {
        if (validator.isValid) {
          mapBoxTheme = {
            cssText: `
                  .Input {
                      height: 43px;
                      font-size: 1rem;
                      font-weight: 400;
                      color: #000;
                      background-color: #dcf5e6;
                      font-family: system-ui;
                      pointer-events: none;
                  }
                  .ClearBtn {
                      display: none !important;
                  }
              `,
            variables: {
              unit: "14px",
              padding: "0.5em",
              border: "1px solid rgb(99, 184, 132)",
              borderRadius: "4px",
              boxShadow: "none",
            },
          };
        } else {
          mapBoxTheme = {
            cssText: `
                .Input {
                    height: 43px;
                    font-size: 1rem;
                    font-weight: 400;
                    color: #000;
                    background-color: #ffece0;
                    font-family: system-ui;
                    pointer-events: none;
                }
                .ClearBtn {
                    display: none !important;
                }
            `,
            variables: {
              unit: "14px",
              padding: "0.5em",
              border: "1px solid #ba2626",
              borderRadius: "4px",
              boxShadow: "none",
            },
          };
        }
      }
      dispatch(
        updateUI({
          key: "form",
          value: {
            fields: {
              ...formFields,
              step3: {
                ...formFields.step3,
                locations: formFields.step3.locations.map((location, index) => {
                  if (index === stateSelectorIndex) {
                    return {
                      ...formFields.step3.locations[index],
                      new: {
                        ...formFields.step3.locations[index]?.new,
                        [field]: {
                          ...formFields.step3.locations[index][field],
                          ...validator,
                          value,
                          mapBoxTheme,
                        },
                      },
                    };
                  }

                  return location;
                }),
              },
            },
          },
        })
      );
      return;
    }

    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              locations: formFields.step3.locations.map((location, index) => {
                if (index === stateSelectorIndex) {
                  return {
                    ...formFields.step3.locations[index],
                    new: {
                      ...formFields.step3.locations[index]?.new,
                      [field]: {
                        ...formFields.step3.locations[index][field],
                        value,
                      },
                    },
                  };
                }

                return location;
              }),
            },
          },
        },
      })
    );
  };

  return (
    <>
      <div className="py-2 w-100 d-flex justify-content-start align-items-center">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "16px",
          }}
        >
          Create new location
        </div>
      </div>
      <div className=" w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-100 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Location point name
          </span>
          <div className="w-100 pl-2">
            <Input
              key={"[stateSelectorIndex]-point-name"}
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.new?.pointName?.class}`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.pointName
                  ?.value || ""
              }
              onChange={(e) => handleFormField("pointName", e?.target?.value)}
              readOnly={true}
            />
            
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Location type
          </span>
          <div className="w-100 pe-2">
            <Input
              key={"[stateSelectorIndex]-location-type"}
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.new?.shipping?.class}`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.shipping
                  ?.value || ""
              }
              onChange={(e) => handleFormField("shipping", e?.target?.value)}
              readOnly={true}
            />
          </div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Geofence radius(meters){" "}
            <ATSToolTip placement={"topRight"} text="Geofence radius in meters">
              <img src={CircleIIcon} className="mx-1" alt="info" />
            </ATSToolTip>
          </span>
          <div className="w-100 pl-2">
            <Input
              key={"[stateSelectorIndex]-radius"}
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.new?.radius?.class}`}
              style={{
                height: '44px'
              }}
              min={1}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.radius
                  ?.value || ""
              }
              onKeyDown={(e) => {if(e.key === "." ){ e.preventDefault();}}}
              onChange={(val) => handleFormField("radius", val)}
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center position-relative">
        <div className="w-100 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Address{" "}
          </span>
          <div className="w-100 pl-2">
            <Input
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.new?.address?.class}`}
              value={
                formFields?.step3?.locations[stateSelectorIndex]?.new?.address
                  ?.value
              }
              onChange={(e) =>
                handleFormField("address", e?.target?.value || e)
              }
              id="address"
              name="address"
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center position-relative">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Latitude
          </span>
          <div className="w-100 pe-2">
            <Input
              key={"[stateSelectorIndex]-latitude"}
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.new?.latitude?.class}`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.latitude
                  ?.value || ""
              }
              onChange={(e) => handleFormField("latitude", e?.target?.value)}
              readOnly={true}
            />
          </div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Longitude
          </span>
          <div className="w-100 pl-2">
            <Input
              key={"[stateSelectorIndex]-longitude"}
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.new?.longitude?.class}`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.longitude
                  ?.value || ""
              }
              onChange={(e) => handleFormField("longitude", e?.target?.value)}
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex justify-content-start align-items-center">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "16px",
          }}
        >
          Set alert
        </div>
      </div>
      <div className="w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Trigger alerts on
          </span>
          <div className="w-100 pe-2">
            <Select
              className={`shipment-form-fields ${formFields?.step3.locations[stateSelectorIndex]?.new?.trigger?.class}`}
              key={"[stateSelectorIndex]-trigger"}
              placeholder="None"
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.trigger
                  ?.value || ""
              }
              onChange={(val) => handleFormField("trigger", val)}
              style={{ width: "100%", minHeight: "44px !important" }}
              options={[
                {
                  value: "entry and exit",
                  label: "Both (Entry and exit)",
                },
                {
                  value: "entry only",
                  label: "Entry only",
                },
                {
                  value: "exit only",
                  label: "Exit only",
                },
              ]}
            />
          </div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Alert type{" "}
            <ATSToolTip text="Severity level of the alert">
              <img src={CircleIIcon} className="mx-1" alt="info" />
            </ATSToolTip>
          </span>
          <div className="w-100 pl-2">
            <Input
              className={`shipment-form-fields`}
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.alerttype
                  ?.value !== undefined
                  ? formFields?.step3.locations[
                      stateSelectorIndex
                    ]?.new?.alerttype?.value
                      ?.charAt(0)
                      .toUpperCase() +
                    formFields?.step3.locations[
                      stateSelectorIndex
                    ]?.new?.alerttype?.value?.slice(1)
                  : "Notification"
              }
              readOnly={true}
            />
          </div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-100 d-flex flex-column justify-content-center align-items-start position-relative">
          <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
            Alert group{" "}
            <ATSToolTip
              placement={"topLeft"}
              text="Alert groups to be notified of the alert"
            >
              <img src={CircleIIcon} className="mx-1" alt="info" />
            </ATSToolTip>
          </span>
          <div className="w-100 pl-2">
            <Select
              className={`shipment-form-fields-alertGroup`}
              key={"[stateSelectorIndex]-alert-group"}
              placeholder="None"
              mode="multiple"
              allowClear
              value={
                formFields?.step3.locations[stateSelectorIndex]?.new?.alertgroup
                  ?.value
              }
              onChange={(val) => handleFormField("alertgroup", val)}
              style={
                formFields?.step3[stateSelectorIndex]?.alertGroup?.value
                  ?.length > 0
                  ? {
                      width: "100%",
                      minHeight: "44px !important",
                    }
                  : {
                      width: "100%",
                      minHeight: "44px !important",
                    }
              }
              options={alertGroupOptions}
            />
          </div>
        </div>
      </div>
    </>
  );
}

NewLocationFormGroup.propTypes = {
  stateSelectorIndex: PropTypes.number.isRequired,
};

export default NewLocationFormGroup;
